import type { QueryClient } from "react-query";

const disposers = new WeakMap<QueryClient, Set<() => void>>();

/** Register non-query work that must stop with its tenant-scoped QueryClient. */
export function registerQueryClientDisposer(queryClient: QueryClient, dispose: () => void): void {
    const registered = disposers.get(queryClient) ?? new Set();
    registered.add(dispose);
    disposers.set(queryClient, registered);
}

/** Dispose tenant-owned work before clearing the corresponding query cache. */
export function disposeQueryClientResources(queryClient: QueryClient): void {
    const registered = disposers.get(queryClient);
    disposers.delete(queryClient);
    registered?.forEach((dispose) => dispose());
}

let activeTenantQueryClient: QueryClient | null = null;

/** Set by `TenantQueryClientProvider` when a tenant client becomes the rendered one;
 *  `null` while none is (signed out, or the first snapshot still restoring). */
export function setActiveTenantQueryClient(queryClient: QueryClient | null): void {
    activeTenantQueryClient = queryClient;
}

/** The tenant client a read outside React (a platform capability) dedupes through,
 *  so it shares the cache and the persisted snapshot with the screens. */
export function getActiveTenantQueryClient(): QueryClient | null {
    return activeTenantQueryClient;
}
